// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2O42_","top":"styles_top__g-r86"};